import { setProps, getProps } from '../props';
import { clearClient } from '../State/client';
import fetchClient from '../Services/fetchClient';

export default (props) => (dispatch) => {
  const oldProps = getProps();
  setProps(props);
  
  // Check if the client ID has changed
  const oldClientId = oldProps && oldProps.match && oldProps.match.params && oldProps.match.params.id;
  const newClientId = props && props.match && props.match.params && props.match.params.id;
  
  if (oldClientId && newClientId && oldClientId !== newClientId) {
    // Clear the old client data and show loading state
    dispatch(clearClient());
    
    // Fetch the new client
    dispatch(fetchClient());
  }
};
